import { render } from "./HtmlReportView.vue?vue&type=template&id=7a018880&scoped=true"
import script from "./HtmlReportView.vue?vue&type=script&lang=js"
export * from "./HtmlReportView.vue?vue&type=script&lang=js"

import "./HtmlReportView.vue?vue&type=style&index=0&id=7a018880&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a018880"],['__file',"src/components/cases/HtmlReportView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7a018880"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7a018880', __exports__)) {
    console.log('reload')
    api.reload('7a018880', __exports__)
  }
  
  module.hot.accept("./HtmlReportView.vue?vue&type=template&id=7a018880&scoped=true", () => {
    console.log('re-render')
    api.rerender('7a018880', render)
  })

}


export default __exports__